import { useNavigate, useLocation } from 'react-router-dom'
import { useWorkspace } from '../../../../../contexts/WorkspaceContext.tsx'
import { useAppDispatch } from '../../../../../store/hooks.ts'
import { setMobileSidebarOpen } from '../../../../../store/ui/uiSlice.ts'
import AllTasksIcon from '../../../../../assets/icons/icon-all-tasks.svg?react'
import SidebarUiButton from '../SidebarUiButton/SidebarUiButton.tsx'
import Tooltip from '@/components/ui/Tooltip/Tooltip'

const SidebarAllTasksButton = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const location = useLocation()
    const { workspace } = useWorkspace()

    const isActive = workspace && location.pathname === `/${workspace.workspaceUrlId}/all-tasks`

    const handleClick = () => {
        if (workspace) {
            navigate(`/${workspace.workspaceUrlId}/all-tasks`)
            dispatch(setMobileSidebarOpen(false))
        }
    }

    return (
        <Tooltip title="All tasks">
            <SidebarUiButton icon={<AllTasksIcon />} title="All tasks" isActive={!!isActive} onClick={handleClick} />
        </Tooltip>
    )
}

export default SidebarAllTasksButton
